<template>
  <div class="USAIDTables">
    <v-container grid-list-md fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md8>
          <v-card>
            <v-card-title class="title">
              Reporte Cuenta Bancaria {{ operName.toUpperCase() }}
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsCB === null">
                  <download-csv
                    :data="dataValsCB"
                    :name="'Reporte Cuenta Bancaria ' + operName.toUpperCase() + '.csv'"
                    :labels="labelsCB"
                    :fields="fieldsCB"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingCB"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headersCB"
                :dataVals="dataValsCB"
                :searchActive="true"
                :key="tableKeyCB"
              />
            </v-card-text>
          </v-card>

          <v-divider/>

          <v-card v-if="loadRUVUR">
            <v-card-title class="title">
              Reporte Rural Urbano
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsRUVUR === null">
                  <download-csv
                    :data="dataValsRUVUR"
                    :name="'Reporte Rural Urbano.csv'"
                    :labels="labelsRUVUR"
                    :fields="fieldsRUVUR"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingRUVUR"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headersRUVUR"
                :dataVals="dataValsRUVUR"
                :searchActive="true"
                :key="tableKeyRUVUR"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableBase'
import JsonCSV from 'vue-json-csv'

export default {
  name: 'USAIDTables',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/projects/usaid_tb/',
        page: 1
      },

      operativo: null,
      operName: null,

      progressSize: 70,
      progressWidth: 7,
      loadingCB: false,
      loadingRUVUR: false,

      headersCB: [
        {
          text: 'Municipio',
          align: 'left',
          value: 'municipio'
          // str: 'Totales'
        },
        { text: 'Davivienda', value: 'davivienda' },
        { text: 'Otros Bancos', value: 'otros' },
        { text: 'Sin Banco', value: 'sin' },
        { text: 'Total', value: 'total' }
      ],
      labelsCB: {
        municipio: 'Municipio',
        davivienda: 'Davivienda',
        otros: 'Otros Bancos',
        sin: 'Sin Banco',
        total: 'Total'
      },
      fieldsCB: ['municipio', 'davivienda', 'otros', 'sin', 'total'],
      dataValsCB: null,
      tableKeyCB: 0,

      headersRUVUR: [
        {
          text: 'Municipio',
          align: 'left',
          value: 'mun'
          // str: 'Totales'
        },
        { text: 'Urbano', value: 'urb' },
        { text: 'Rural', value: 'rur' }
      ],
      labelsRUVUR: {
        mun: 'Municipio',
        urb: 'Urbano',
        rur: 'Rural'
      },
      fieldsRUVUR: ['mun', 'urb', 'rur'],
      dataValsRUVUR: null,
      loadRUVUR: false,
      tableKeyRUVUR: 0
    }
  },

  watch: {
    operativo: function () {
      this.changeData()
    }
  },

  computed: {},

  methods: {
    /** Carga la tabla de Cuenta Bancaria
     */
    loadTableCB () {
      this.loadingCB = true
      this.dataValsCB = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operName,
          reporte: 'banco',
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsCB = resp.data
          t.loadingCB = false
          t.tableKeyCB += 1
        })
        .catch(err => console.error(err))
    },

    /** Carga la tabla de rural vs Urbano
     */
    loadTableRUVUR () {
      this.loadingRUVUR = true
      this.dataValsRUVUR = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: 'usuario',
          reporte: 'zona',
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRUVUR = resp.data
          t.loadingRUVUR = false
          t.tableKeyRUVUR += 1
        })
        .catch(err => console.error(err))
    },

    /** Cambia las tablas segun el operativo
     */
    changeData () {
      if (this.operativo === 19) { // USAID Usuarios Producción
        this.operName = 'usuario'
        this.loadRUVUR = true
        this.loadTableRUVUR()
      } else if (this.operativo === 20) { // USAID Comercio Producción
        this.operName = 'comercio'
        this.loadRUVUR = false
      }
      this.loadTableCB()
    }
  }
}
</script>
